import { render, staticRenderFns } from "./SipExtension.vue?vue&type=template&id=6b19338f"
import script from "./SipExtension.vue?vue&type=script&lang=js"
export * from "./SipExtension.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports